export function readNavGridMemory(runtimeWindow = globalThis?.window) {
  if (!runtimeWindow) return null;
  const grid = runtimeWindow.__trekkinNavGridMem;
  if (!grid || typeof grid !== "object") return null;

  // Os escritores da cache recebem uma grelha já normalizada. Devolver a mesma
  // referência evita copiar e normalizar centenas de milhares de pontos em cada
  // chamada feita durante os renders do mapa.
  return grid;
}

export function writeNavGridMemory(grid, runtimeWindow = globalThis?.window) {
  if (!runtimeWindow || !grid || typeof grid !== "object") return false;
  try {
    runtimeWindow.__trekkinNavGridMem = grid;
    return true;
  } catch {
    return false;
  }
}
